import React, { useId, useState } from 'react';
const FormField = ({ label, name, placeholder = null, formData, setFormData, constraints = null, informations = null, expanded = false, forceError = false, options = [], required = false, type = "text", pll, validate = (value) => {
    return { isValid: true, message: null };
} }) => {
    const [hasChanged, setHasChanged] = useState(false);
    const checkConstrains = (constraints, value) => {
        let cs = constraints.split(",");
        let isValid = true;
        switch (true) {
            case cs.includes('email'):
                isValid = (/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i).test(value);
                if (!isValid) {
                    return {
                        isValid: false,
                        message: pll("Veuillez encoder une adresse e-mail valide")
                    };
                }
            case cs.includes("minlength"):
                isValid = value.length >= 3 && value != "";
                if (!isValid) {
                    return {
                        isValid: false,
                        message: pll("La valeur ne peut être inférieure à 3")
                    };
                }
        }
        if (required == true) {
            isValid = value != "";
            if (!isValid) {
                return {
                    isValid: false,
                    message: pll("Veuillez remplir ce champ")
                };
            }
        }
        if (isValid) {
            return {
                isValid: true,
                message: null
            };
        }
    };
    const FormError = ({ message = null }) => {
        if (forceError && !hasChanged) {
            message = pll("Veuillez remplir ce champ");
        }
        return (message ? React.createElement("div", { className: "form-error" }, message) : React.createElement(React.Fragment, null));
    };
    const [message, setMessage] = useState(0);
    const handleChange = (e) => {
        setHasChanged(true);
        let isValidFn;
        let value = e.target.value;
        if (constraints != null) {
            isValidFn = checkConstrains(constraints, value);
        }
        else {
            if (required == true) {
                let isValid = value != "";
                if (!isValid) {
                    isValidFn = {
                        isValid: false,
                        message: pll("Veuillez remplir ce champ")
                    };
                }
                else {
                    isValidFn = validate(value);
                }
            }
            else {
                isValidFn = validate(value);
            }
        }
        let data = Object.assign({}, formData);
        data[name] = value;
        data.globalErrors[name] = false;
        setFormData(data);
        setMessage(isValidFn.isValid ? 0 : isValidFn.message);
        if (isValidFn.isValid && data.globalErrors[name] !== void 0) {
            data.globalErrors[name] = true;
            setFormData(data);
        }
    };
    const id = useId();
    // Construct select options for choice element
    let selectOptions;
    if (type == "choice") {
        selectOptions = options.map((element, index) => {
            return (React.createElement("option", { value: element.value }, element.label));
        });
    }
    if (type == "checkbox") {
        return (React.createElement("div", { className: `form-row field-` + name },
            React.createElement("div", { className: "form-control" },
                React.createElement("input", { type: "hidden", name: name, value: "0" }),
                React.createElement("input", { id: id, name: name, type: "checkbox", required: required == true ? "required" : "", placeholder: placeholder, value: "1", onChange: handleChange }),
                " ",
                React.createElement("label", { htmlFor: id, dangerouslySetInnerHTML: { __html: label + (required ? "*" : "") + (informations != null ? React.createElement("span", { className: "informations" }, informations) : "") } })),
            React.createElement(FormError, { message: message })));
    }
    //
    return (React.createElement("div", { className: `form-row field-` + name },
        React.createElement("label", { htmlFor: id },
            label,
            required ? "*" : "",
            " ",
            informations != null ? React.createElement("span", { className: "informations" }, informations) : ""),
        React.createElement("div", { className: "form-control" }, type == "choice" ?
            (React.createElement("select", { id: id, name: name, onChange: handleChange, defaultValue: formData[name] }, selectOptions))
            : React.createElement("input", { id: id, name: name, type: type, required: required == true ? "required" : "", placeholder: placeholder, value: formData[name], onChange: handleChange })),
        React.createElement(FormError, { message: message })));
};
export default FormField;
